<template>
  <myDialog
    :isDialog="isDialog"
    :title="isView ? '查看培训项目' : isEdit ? '编辑培训项目' : '添加培训项目'"
    :width="'1000px'"
    @handleClose="handleClose"
  >
    <template slot="content">
      <el-form
        :model="formData"
        :rules="rules"
        ref="form"
        label-width="180px"
        class="box"
        v-loading="formLoading"
        element-loading-text="加载中..."
        element-loading-background="rgba(255, 255, 255, 0.72)"
      >
        <el-form-item label="培训项目名称" prop="name" required>
          <el-input
            v-model="formData.name"
            placeholder="请输入培训项目名称"
            :disabled="isView"
          ></el-input>
        </el-form-item>

        <el-form-item label="培训项目等级" prop="levelCode">
          <el-select
            v-model="formData.levelCode"
            placeholder="请选择培训项目等级"
            clearable
            style="width: 100%"
            :disabled="isView"
            @change="handleLevelChange"
          >
            <el-option
              v-for="item in levelOptions"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="项目简介" prop="briefIntroduction">
          <el-input
            v-model="formData.briefIntroduction"
            type="textarea"
            :rows="3"
            placeholder="请输入项目简介"
            :disabled="isView"
          ></el-input>
        </el-form-item>
      </el-form>
    </template>
    <template slot="footer">
      <div>
        <el-button v-if="!isView" type="primary" @click="handleSubmit" :loading="loading">保存</el-button>
        <el-button @click="handleClose">{{ isView ? "关闭" : "取消" }}</el-button>
      </div>
    </template>
  </myDialog>
</template>

<script>
import { addOrganizations, editOrganizations, getTrainingProjectDetail } from "@/api/training";
import { getListByDictType } from "@/api/sys/dictData";

export default {
  name: "PolicyDialog",
  props: {
    isDialog: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isView: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: {
        id: undefined,
        name: "",
        levelCode: "",
        levelName: "",
        briefIntroduction: "",
      },
      levelOptions: [],
      formLoading: false,
      loading: false,
      rules: {
        name: [{ required: true, message: "请输入培训项目名称", trigger: "blur" }],
      },
    };
  },
  watch: {
    editData: {
      handler(newVal) {
        if (newVal && (this.isEdit || this.isView) && Object.keys(newVal).length > 0) {
          this.applyRowToForm(newVal);
        }
      },
      immediate: true,
      deep: true,
    },
    isDialog(val) {
      if (!val) {
        this.resetForm();
      } else if (val && this.editData && this.editData.id && (this.isEdit || this.isView)) {
        this.getDetail();
      }
    },
  },
  created() {
    this.loadLevelDict();
  },
  methods: {
    async loadLevelDict() {
      try {
        const res = await getListByDictType("cultivate_project_level");
        if (res && res.code === 200 && res.data) {
          this.levelOptions = res.data;
        }
      } catch (error) {
        console.error("加载培训项目等级字典失败", error);
      }
    },
    async getDetail() {
      if (!this.editData || !this.editData.id) return;
      this.formLoading = true;
      try {
        const res = await getTrainingProjectDetail(this.editData.id);
        if (res && res.code === 200 && res.data) {
          this.applyRowToForm(res.data);
        }
      } catch (error) {
        console.error("获取培训项目详情失败", error);
        this.$message.error("获取详情失败");
      } finally {
        this.formLoading = false;
      }
    },
    resolveLevelName(data) {
      if (data.levelName) return data.levelName;
      if (data.levelCode && this.levelOptions.length) {
        const opt = this.levelOptions.find((item) => item.dictValue == data.levelCode);
        return opt ? opt.dictLabel : "";
      }
      return "";
    },
    applyRowToForm(data) {
      this.formData = {
        id: data.id,
        name: data.name || "",
        levelCode: data.levelCode != null ? String(data.levelCode) : "",
        levelName: this.resolveLevelName(data),
        briefIntroduction: data.briefIntroduction || "",
      };
    },
    handleLevelChange(value) {
      if (!value) {
        this.formData.levelName = "";
        return;
      }
      const selected = this.levelOptions.find((item) => item.dictValue == value);
      this.formData.levelName = selected ? selected.dictLabel : "";
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const submitData = {
          name: this.formData.name,
          levelCode: this.formData.levelCode,
          levelName: this.formData.levelName,
          briefIntroduction: this.formData.briefIntroduction,
        };
        if (this.isEdit && this.formData.id) {
          submitData.id = this.formData.id;
        }
        const api = this.isEdit ? editOrganizations : addOrganizations;
        api(submitData)
          .then((res) => {
            if (res && res.code === 200) {
              this.$message.success(this.isEdit ? "编辑成功" : "新增成功");
              this.$emit("success");
              this.handleClose();
            } else {
              this.$message.error(res.msg || "操作失败");
            }
          })
          .catch((err) => {
            console.error("请求出错", err);
            this.$message.error("操作失败");
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    handleClose() {
      this.$emit("handleClose");
      this.resetForm();
    },
    resetForm() {
      this.formLoading = false;
      this.$refs.form && this.$refs.form.resetFields();
      this.formData = {
        id: undefined,
        name: "",
        levelCode: "",
        levelName: "",
        briefIntroduction: "",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-form-item__label {
  color: #2a3347 !important;
  font-weight: 400;
  font-size: 16px;
}

/deep/ .el-dialog__header {
  background: #297dee !important;
}

/deep/ .el-dialog__title {
  color: #ffffff !important;
  font-weight: 700;
  font-size: 17px;
}

/deep/ .el-dialog__headerbtn {
  filter: brightness(0) invert(1) !important;
}
.box {
  min-height: 200px;
  background: white;
}
</style>
